import { render, staticRenderFns } from "./DriversCard.vue?vue&type=template&id=27c38131&scoped=true&"
import script from "./DriversCard.vue?vue&type=script&lang=js&"
export * from "./DriversCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c38131",
  null
  
)

export default component.exports